import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { useInternalGraphLinking } from 'src/app/graph/hooks/useInternalGraphLinking';
import { assertUnreachable } from 'src/lib/assertUnreachable';

import { FeedbackAdmonition } from './FeedbackAdmonition';

export const checkTabs = ['Schemas', 'Tasks', 'Details'] as const;

export function CheckSidebar({ children }: { children?: React.ReactNode }) {
  const location = useLocation();
  const {
    isProposalRoute,
    currentCheckSchemasRoute,
    currentCheckRoute,
    currentCheckTasksRoute,
    currentCheckDetailsRoute,
  } = useInternalGraphLinking();
  if (!isProposalRoute && !children) return null;
  return (
    <div className="flex w-1/6 min-w-[300px] flex-none flex-col space-y-6 p-6">
      <div className="space-y-6 overflow-y-auto">
        {isProposalRoute && (
          <div className="space-y-2 border-l border-primary">
            {checkTabs.map((tabName) => (
              <NavLink
                key={tabName}
                to={(tabName === 'Schemas'
                  ? currentCheckSchemasRoute
                  : tabName === 'Details'
                    ? currentCheckDetailsRoute
                    : tabName === 'Tasks'
                      ? currentCheckTasksRoute
                      : assertUnreachable(tabName)
                ).locationFrom({
                  location,
                  fromRouteConfig: currentCheckRoute,
                })}
                className="ml-[-1px] flex w-full items-center before:mr-2 before:inline-block before:h-8 before:w-1 hover:no-underline"
                activeClassName="font-semibold before:bg-border-tab"
              >
                {tabName}
              </NavLink>
            ))}
          </div>
        )}
        {children}
      </div>
      <FeedbackAdmonition />
    </div>
  );
}
